import React, { ChangeEvent, useState } from 'react'

import { addFaqResponse } from '../../../../api/faq'
import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { ReactComponent as Close } from '../../../../assets/icons/close.svg'
import { ReactComponent as Earth } from '../../../../assets/icons/earth.svg'

import styles from './faq-new-response.module.scss'

interface INewResponseFormProps {
    selectedFaqItem: string
    getDataFromApi: () => void
    onCancel: () => void
}

function NewResponseForm(props: INewResponseFormProps) {
    const { selectedFaqItem, getDataFromApi, onCancel } = props
    const [formData, setFormData] = useState({
        text: '',
        value: 'pl',
    })

    const handleInputChange = (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        field: string
    ) => {
        setFormData({
            ...formData,
            [field]: e.target.value,
        })
    }

    const handleAddFaqResponse = async (e: React.FormEvent) => {
        e.preventDefault()
        try {
            const newResponseObj = {
                text: formData.text,
                condition: [
                    {
                        name: 'user_language',
                        type: 'slot',
                        value: formData.value,
                    },
                ],
            }
            await addFaqResponse(selectedFaqItem, newResponseObj)

            getDataFromApi()

            setFormData({
                text: '',
                value: '',
            })
        } catch (error) {
            console.error('ERROR:', error)
        }
    }

    const setAddButtonActive = () =>
        !(formData.text.trim() && formData.value.trim())

    return (
        <div className={styles.faqNewResponse}>
            <form onSubmit={handleAddFaqResponse}>
                <div className={styles.faqNewResponse__sectionWrapper}>
                    <div>
                        <textarea
                            className={styles.faqNewResponse__textAreaWrapper}
                            value={formData.text}
                            onChange={(e) => handleInputChange(e, 'text')}
                        />
                    </div>

                    <div className={styles.faqNewResponse__section}>
                        <div className={styles.faqNewResponse__language}>
                            <Earth
                                className={
                                    styles.faqNewResponse__language__languageIcon
                                }
                            />
                            <input
                                className={
                                    styles.faqNewResponse__language__languageInput
                                }
                                value={formData.value}
                                onChange={(e) => handleInputChange(e, 'value')}
                            />
                        </div>

                        <button
                            className={`${styles.faqNewResponse__borderBtn} ${
                                setAddButtonActive()
                                    ? styles.faqNewResponse__disabledBtn
                                    : ''
                            }`}
                            type="submit"
                        >
                            <CheckmarkCircle />
                        </button>
                        <button
                            type="button"
                            className={styles.faqNewResponse__borderBtn}
                            onClick={onCancel}
                        >
                            <Close />
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default NewResponseForm
